
        import 'Modal.b2391c5.css-module'
        export default {"modal":"modal_Modal_b2391c5"}
    